<template>
  <div class="page-width">
    <div v-show="login===true" class="login">
      <h2>{{ $t('adminLogin') }}</h2>
      <p v-if="loginErrorMessage" style="padding-bottom: 20px; color: red">
        <b>{{ loginErrorMessage }}</b>
      </p>
      <p v-if="newPasswordResetMessage" style="padding:10px; border: 1px, solid rgb(3, 211, 252)">
      <h3>{{ newPasswordResetMessage }}</h3>
      </p>
      <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
        <el-form-item v-bind:label="$t('userName')">
          <el-input v-model="formLabelAlign.username"></el-input>
        </el-form-item>
        <el-form-item v-bind:label="$t('password')">
          <el-input v-model="formLabelAlign.password" type="password"></el-input>
        </el-form-item>
        <el-form-item v-bind:label="$t('customerEmail')">
          <el-input v-bind:placeholder="$t('emailHint')" v-model="formLabelAlign.customerEmail"></el-input>
        </el-form-item>
      </el-form>
      <div class="text-center">
        <p>
          <button @click="Login(formLabelAlign)">{{ $t('signIn') }}</button>
        </p>
      </div>
    </div>
    <div v-show="login===false" class="account">
      <div class="text-center">
        <h2>{{ $t('resetPassword') }}</h2>
        <p>{{ $t('resetSendEmail') }}</p>
        <p v-if="couldNotFindEmail" style="color: red">{{ $t('noAccountWithEmail') }}</p>
      </div>
      <div class="form-vertical">
        <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
          <el-form-item label="Email">
            <el-input v-model="email"></el-input>
          </el-form-item>
          <div class="text-center">
            <p>
              <el-button class="btn" @click="resetEmailRequest(email)">{{ $t('submit') }}</el-button>
            </p>
            <p class="pointer" @click="ForgotPassword">{{ $t('cancel') }}</p>
          </div>
        </el-form>
      </div>
    </div>
    ​

  </div>
</template>
​
​
<script>
  import {mapActions, mapState} from 'vuex';
  import Router from '../../router';
  import {isUserAuthenticated} from '../../store/modules/cart';

  function getDefaultData() {
    return {
      labelPosition: 'top',
      formLabelAlign: {
        username: '',
        password: '',
      },
      email: '',
      login: true, //true showlogin; false forget password
      showModal: false,
      showChangeToNewPassword: false,
      newPasswordResetMessage: '',
      verification: '',
      tempToken: '',
      newpassword: '',
      verificationCodeFail: false,
    }
  }

  export default {
    name: "AdminLogin",
    data() {
      return {
        labelPosition: 'top',
        formLabelAlign: {
          username: '',
          password: '',
          customerEmail: '',
        },
        email: '',
        login: true, //true showlogin; false forget password
        showModal: false,
        showChangeToNewPassword: false,
        newPasswordResetMessage: '',
        verification: '',
        tempToken: '',
        newpassword: '',
        couldNotFindEmail: false,
        verificationCodeFail: false,
      }
    },
    methods: {
      ...mapActions('auth', ['AdminLoginRequest', 'resetEmail', 'sentVerificationCode', 'resetPassword']),
      ForgotPassword() {
        this.newPasswordResetMessage = '',
          // this.loginErrorMessage = '',
          this.login = !this.login
      },
      Login(form) {
        this.AdminLoginRequest(form);
      },
      cancelEnteringVerificationCode() {
        this.showModal = false
      }
    },
    beforeRouteLeave(to, from, next) {
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/getCart');
        this.$store.dispatch('auth/fetchCustomerInformation');
      } else {
        this.$store.dispatch('cart/fetchCartProducts');
        this.$store.dispatch('auth/fetchCustomerInformation');
      }
      next();
    },
    computed: mapState({
      loginErrorMessage: state => state.auth.loginErrorMessage
    }),
  }
</script>
​
​
<style scoped lang="less">
  @import "../../assets/css/public";
  @import "../../assets/css/login";
</style>



// WEBPACK FOOTER //
// src/view/Auth/adminLogin.vue